import { APIClient } from "../../helpers/api_helper";
import * as url from "../../helpers/url_helper";

const api = new APIClient();

export const getAllActiveBranchesApi = () =>
    api.get(url.GET_ALL_ACTIVE_BRANCHES);
